module.exports = __webpack_public_path__ + "img/chat.466a0bd3.png";